export const eventCategories = [
  {
    name: "Social Events",
    slug: "social-event",
    image: process.env.PUBLIC_URL + '/images/social.jpg',
  },
  {
    name: "Corporate Events",
    slug: "corporate-event",
    image: process.env.PUBLIC_URL + '/images/cooporate.jpg',
  },
  {
    name: "Community Events",
    slug: "community-event",
    image: process.env.PUBLIC_URL + '/images/community.jpg',
  },
  {
    name: "Festivals",
    slug: "festival",
    image: process.env.PUBLIC_URL + '/images/festival.jpg',
  },
  {
    name: "Performances",
    slug: "performance",
    image: process.env.PUBLIC_URL + '/images/performance.jpg',
  },
  {
    name: "Food & Drinks Events",
    slug: "food-and-drinks-event",
    image: process.env.PUBLIC_URL + '/images/food&drinks.jpg',
  },
  {
    name: "Virtual Events",
    slug: "virtual-event",
    image: process.env.PUBLIC_URL + '/images/virtual.jpg',
  },
  {
    name: "Outdoor Events",
    slug: "outdoor-event",
    image: process.env.PUBLIC_URL + '/images/outdoor.jpg',
  },
  {
    name: "Kids Events",
    slug: "kids-event",
    image: process.env.PUBLIC_URL + '/images/kidsfun.jpg',
  },
];
